import { useLingui } from "@lingui/react/macro";
import { useParams } from "react-router";
import { z } from "zod";
import * as Sentry from "@sentry/react";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Loading } from "@medoma/components/Loading/Loading";
import { useVisit } from "@/api/Routes";
import { deducedError } from "@/Utils/ErrorUtils";
import { DeclinePatient } from "@/pages/ambulating/patients/$patientId/decline/DeclinePatient";

export const DeclinePatientInVisit = () => {
  const { t } = useLingui();
  const { routeId, visitId } = z
    .object({ routeId: z.string(), visitId: z.string() })
    .parse(useParams());
  const { data: visit, isPending, isError, error } = useVisit(routeId, visitId);

  if (isPending) {
    return <Loading message={t`Hämtar patientinformation`} />;
  }

  if (isError) {
    Sentry.captureException(error);
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta patientinformation.`} ${deducedError(error)}`}
      />
    );
  }

  return (
    <DeclinePatient patient={visit.patient} continueTo="/routesAndActivities" />
  );
};
